var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66663 0.833252C7.12686 0.833252 7.49996 1.20635 7.49996 1.66659V2.49992H12.5V1.66659C12.5 1.20635 12.8731 0.833252 13.3333 0.833252C13.7935 0.833252 14.1666 1.20635 14.1666 1.66659V2.49992H15C16.8409 2.49992 18.3333 3.9923 18.3333 5.83325V14.9999C18.3333 16.8409 16.8409 18.3333 15 18.3333H4.99996C3.15901 18.3333 1.66663 16.8409 1.66663 14.9999V5.83325C1.66663 3.9923 3.15901 2.49992 4.99996 2.49992H5.83329V1.66659C5.83329 1.20635 6.20639 0.833252 6.66663 0.833252ZM12.5 4.16659C12.5 4.62682 12.8731 4.99992 13.3333 4.99992C13.7935 4.99992 14.1666 4.62682 14.1666 4.16659H15C15.9204 4.16659 16.6666 4.91278 16.6666 5.83325V6.24992H3.33329V5.83325C3.33329 4.91278 4.07948 4.16659 4.99996 4.16659H5.83329C5.83329 4.62682 6.20639 4.99992 6.66663 4.99992C7.12686 4.99992 7.49996 4.62682 7.49996 4.16659H12.5ZM16.6666 7.91658H3.33329V14.9999C3.33329 15.9204 4.07948 16.6666 4.99996 16.6666H15C15.9204 16.6666 16.6666 15.9204 16.6666 14.9999V7.91658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.647e129eacd7b287aa25dde24af9c2c2.svg";
export { ForwardRef as ReactComponent };